export const aftersales = {
  CANCEL: 'CANCEL',
  REBOOK: 'REBOOK'
};
